import { render } from "./AdultClinicPage.vue?vue&type=template&id=b7f4ecc0"
import script from "./AdultClinicPage.vue?vue&type=script&lang=js"
export * from "./AdultClinicPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__